import React from "react";
import { StaticQuery, graphql } from "gatsby";

import Section from "../organisms/section";

import HeaderTitle from "../molecules/header-title";
import SolutionScrollHeader from "../molecules/solution-scroll-header";
import Solution from "../molecules/solution";
import ToggleableSection from "../molecules/toggleable-section";

import "../../scss/organisms/_solution-scroll.scss";

class SolutionScroll extends React.Component {
  urlHashTitles = ["think", "create", "accelerate"];
  currentIndex =
    this.props.location.hash && this.props.location.hash.length
      ? this.urlHashTitles.indexOf(this.props.location.hash.substring(1))
      : 0;
  selectedIndex =
    this.props.location.hash && this.props.location.hash.length
      ? this.currentIndex
      : -1;
  state = { activeIndex: this.currentIndex };

  setActiveIndex = (index, silent) => {
    if (this.state.activeIndex === index) {
      return;
    }

    this.setState({ activeIndex: index });

    if (!silent) {
      history.replaceState(null, null, "#" + this.urlHashTitles[index]);
    }
  };

  scrollToIndex = index => {
    if (
      index === undefined ||
      !this.sections ||
      !this.sections.length ||
      !this.sections[index]
    ) {
      return;
    }

    const y =
      this.sections[index].getBoundingClientRect().top +
      window.pageYOffset -
      147;
    window.scrollTo(0, y);
  };

  componentDidMount = () => {
    this.sections = document.querySelectorAll(".solution-scroll-body .section");

    this.scrollToIndex(this.selectedIndex);

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          let opacity = entry.intersectionRatio;

          if (entry.intersectionRatio <= 0.3) {
            opacity = 0;
          } else if (entry.intersectionRatio >= 0.7) {
            opacity = 1;
            const activeIndex = Array.prototype.indexOf.call(
              entry.target.parentNode.childNodes,
              entry.target
            );

            this.setActiveIndex(activeIndex, true);
          }

          entry.target.style.opacity = opacity;
        });
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
    );

    this.sections.forEach(image => {
      this.observer.observe(image);
    });
  };

  componentWillUnmount = () => {
    if (this.observer) {
      this.observer.disconnect();
    }
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query solutionScrollQuery {
            enSolutions: allContentfulSolution(
              filter: { node_locale: { eq: "en-EU" } }
            ) {
              edges {
                node {
                  id
                  title
                  body {
                    body
                  }
                  category
                  solutionCategory {
                    id
                  }
                  icon {
                    title
                    file {
                      url
                    }
                  }
                }
              }
            }
            nlSolutions: allContentfulSolution(
              filter: { node_locale: { eq: "nl-BE" } }
            ) {
              edges {
                node {
                  id
                  title
                  body {
                    body
                  }
                  category
                  solutionCategory {
                    id
                  }
                  icon {
                    title
                    file {
                      url
                    }
                  }
                }
              }
            }
            enCategory: allContentfulSolutionCategory(
              sort: { fields: [order], order: ASC }
              filter: { node_locale: { eq: "en-EU" } }
            ) {
              edges {
                node {
                  id
                  title
                  body {
                    body
                  }
                }
              }
            }
            nlCategory: allContentfulSolutionCategory(
              sort: { fields: [order], order: ASC }
              filter: { node_locale: { eq: "nl-BE" } }
            ) {
              edges {
                node {
                  id
                  title
                  body {
                    body
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const solutions =
            this.props.language && this.props.language === "nl"
              ? data.nlSolutions.edges
              : data.enSolutions.edges;
          const categories =
            this.props.language && this.props.language === "nl"
              ? data.nlCategory.edges
              : data.enCategory.edges;

          const solutionThink = solutions.filter(item => {
              return item.node.solutionCategory.id === categories[0].node.id;
            }),
            solutionCreate = solutions.filter(item => {
              return item.node.solutionCategory.id === categories[1].node.id;
            }),
            solutionAccelerate = solutions.filter(item => {
              return item.node.solutionCategory.id === categories[2].node.id;
            });

          return (
            <div className="solution-scroll">
              <SolutionScrollHeader
                activeIndex={this.state.activeIndex}
                setActiveIndex={index => {
                  this.setActiveIndex(index);
                  this.scrollToIndex(index);
                }}
              />
              <div className="solution-scroll-body">
                <Section
                  className="pt-3 pb-3 pt-md-3 pb-md-5"
                  active={this.state.activeIndex === 0}
                >
                  <ToggleableSection
                    toggle={
                      <HeaderTitle
                        title={categories[0].node.title}
                        active={this.props.activeIndex === 0}
                        withBorder={true}
                      />
                    }
                    active={this.selectedIndex === 0}
                    hashTitle={this.urlHashTitles[0]}
                  >
                    <div className="row">
                      <div className="col-md-8">
                        <p>{categories[0].node.body.body}</p>
                      </div>
                    </div>

                    <div className="row">
                      {solutionThink.map(item => {
                        return (
                          <div className="col-md-6" key={item.node.id}>
                            <Solution
                              title={item.node.title}
                              description={item.node.body.body}
                              icon={item.node.icon.file.url}
                              iconAlt={item.node.icon.title}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </ToggleableSection>
                </Section>
                <Section
                  className="pt-3 pb-3 pt-md-3 pb-md-5"
                  active={this.state.activeIndex === 1}
                >
                  <ToggleableSection
                    toggle={
                      <HeaderTitle
                        title={categories[1].node.title}
                        active={this.props.activeIndex === 1}
                        withBorder={true}
                      />
                    }
                    active={this.selectedIndex === 1}
                    hashTitle={this.urlHashTitles[1]}
                  >
                    <div className="row">
                      <div className="col-md-8">
                        <p>{categories[1].node.body.body}</p>
                      </div>
                    </div>

                    <div className="row">
                      {solutionCreate.map(item => {
                        return (
                          <div className="col-md-6" key={item.node.id}>
                            <Solution
                              title={item.node.title}
                              description={item.node.body.body}
                              icon={item.node.icon.file.url}
                              iconAlt={item.node.icon.title}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </ToggleableSection>
                </Section>
                <Section
                  className="pt-3 pb-3 pt-md-3 pb-md-5"
                  active={this.state.activeIndex === 2}
                >
                  <ToggleableSection
                    toggle={
                      <HeaderTitle
                        title={categories[2].node.title}
                        active={this.props.activeIndex === 2}
                        withBorder={true}
                      />
                    }
                    active={this.selectedIndex === 2}
                    hashTitle={this.urlHashTitles[2]}
                  >
                    <div className="row">
                      <div className="col-md-8">
                        <p>{categories[2].node.body.body}</p>
                      </div>
                    </div>

                    <div className="row">
                      {solutionAccelerate.map(item => {
                        return (
                          <div className="col-md-6" key={item.node.id}>
                            <Solution
                              title={item.node.title}
                              description={item.node.body.body}
                              icon={item.node.icon.file.url}
                              iconAlt={item.node.icon.title}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </ToggleableSection>
                </Section>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

export default SolutionScroll;
